export default "__VITE_ASSET__Bm1w4kXz__"